/**
 * Handles the Sinapsi devices Equobox medium
 */
export enum EquoboxMedium {
  EQUOBOX_MEDIUM_OTHER = "00",
  EQUOBOX_MEDIUM_OIL = "01",
  EQUOBOX_MEDIUM_ELECTRICITY = "02",
  EQUOBOX_MEDIUM_GAS = "03",
  EQUOBOX_MEDIUM_HEAT = "04",
  EQUOBOX_MEDIUM_STEAM = "05",
  EQUOBOX_MEDIUM_HOT_WATER = "06",
  EQUOBOX_MEDIUM_WATER = "07",
  EQUOBOX_MEDIUM_HEAT_COST_ALLOCATOR = "08",
  EQUOBOX_MEDIUM_COOLING_LOAD_METER_VOLUME_RETURN_TEMP_OUTLET = "0A",
  EQUOBOX_MEDIUM_COOLING_LOAD_METER_VOLUME_FLOW_TEMP_INLET = "0B",
  EQUOBOX_MEDIUM_HEAT_VOLUME_FLOW_TEMP_INLET = "0C",
  EQUOBOX_MEDIUM_HEAT_COOLING_LOAD_METER = "0D",
  EQUOBOX_MEDIUM_HEAT_BUS_SYSTEM = "0E",
  EQUOBOX_MEDIUM_COLD_WATER = "16",
  EQUOBOX_MEDIUM_HEAT_DUAL_WATER = "17",
  EQUOBOX_MEDIUM_HEAT_PRESSURE = "18",
  EQUOBOX_MEDIUM_HEAT_A_D_CONVERTER = "19",
  EQUOBOX_MEDIUM_HEAT_UNKNOWN_MEDIUM = "0F",
}
